export default __webpack_public_path__ + "static/media/BadSmiley.75af27a7.svg";